import * as React from "react";

import { DropdownContext } from "./DropdownProvider";

export const DropdownClearInputButton = (props: React.PropsWithChildren<any>) => {
    const { children } = props;
    const {
        classes, labelText, inputValue, isOpen, onClearButtonClick
    } = React.useContext(DropdownContext);

    return inputValue && isOpen ? (
        <button
            className={classes?.inputClearButton}
            type="button"
            onClick={onClearButtonClick}
            aria-label={`Clear ${labelText}`}
        >
            {children}
        </button>
    ) : null;
};
